/* tslint:disable quotemark */
/* tslint:disable max-line-length */
export const en = {
    "Error": {
      "Continue": "Continue",
      "LoginAsDiffrentUser": "Login as different user",
      "Logout": "Logout"
    },
    "E0": {
        "title": "Connection Failed",
        "message": "The connection to the server failed. Please try again",
        "1": {
            "title": "Connection Failed",
            "message": "The connection to the authorization server failed or client settings are invalid. Please try again.",
        }
    },
    "E400": {
        "title": "Bad Request",
        "message": "The request cannot be fulfilled due to bad syntax.",
        "1": {
            "title": "Your session has expired",
            "message": "Please login again."
        }
    },
    "E401": {
        "title": "Unauthorized",
        "message": "The request was a legal request, but requires user authentication.",
        "1": {
            "title": "An active session is required",
            "message": "The request was a legal request, but requires user authentication or your session has expired."
        }
    },
    "E403": {
        "title": "Forbidden",
        "message": "The server understood the request, but is refusing to fulfill it.",
        "1": {
            "title": "Access Denied",
            "message": "The server understood the request, but you don't have the approriate permission to access this resource."
        },
      "2": {
        "title": "Access Denied",
        "message": "The server understood the request, but you are not an enabled user and you don't have the appropriate permission" +
          " to access this resource"
      },
      "3": {
      "title": "Access Denied",
      "message": "The server understood the request, but there are no active departments in this resource " +
        "or the user has no rights in any of the departments of the institution."
    }
    },
    "E404": {
        "title": "Not Found",
        "message": "The requested resource could not be found but may be available again in the future.",
        "1": {
            "title": "Your profile cannot be found",
            "message": "Please try again. If the problem persists, please contact the system administrators."
        },
        "2": {
            "title": "User profile cannot be found",
            "message": "Please try again. If the problem persists, please contact the system administrators."
        },
        "3": {
            "title": "Application cannot be found",
            "message": "Please try again. If the problem persists, please contact the system administrators."
        },
        "4": {
            "title": "Contract cannot be found",
            "message": "Please try again. If the problem persists please contact to system administrators."
        }
    },
    "E405": {
        "title": "Method Not Allowed",
        "message": "A request was made of a resource using a request method not supported by that resource."
    },
    "E406": {
        "title": "Not Acceptable",
        "message": "The requested resource is only capable of generating content not acceptable according to the Accept headers sent in the request."
    },
    "E407": {
        "title": "Proxy Authentication Required",
        "message": "The client must first authenticate itself with the proxy."
    },
    "E408": {
        "title": "Request Timeout",
        "message": "The server timed out waiting for the request.",
      "1": {
        "title": "Connection Failed",
        "message": "The connection to the server failed. Please try again"
      }
    },
    "E409": {
        "title": "Conflict",
        "message": "The request could not be completed due to a conflict with the current state of the resource."
    },
    "E410": {
        "title": "Gone",
        "message": "The resource requested is no longer available and will not be available again."
    },
    "E411": {
        "title": "Length Required",
        "message": "The request did not specify the length of its content, which is required by the requested resource."
    },
    "E412": {
        "title": "Precondition Failed",
        "message": "The server does not meet one of the preconditions that the requester put on the request."
    },
    "E413": {
        "title": "Payload Too Large",
        "message": "The request is larger than the server is willing or able to process."
    },
    "E414": {
        "title": "Request-URI Too Long",
        "message": "The URI provided was too long for the server to process."
    },
    "E415": {
        "title": "Request Entity Too Large",
        "message": "The request is larger than the server is willing or able to process."
    },
    "E416": {
        "title": "Requested Range Not Satisfiable",
        "message": "The client has asked for a portion of the file, but the server cannot supply that portion."
    },
    "E417": {
        "title": "Expectation Failed",
        "message": "The server cannot meet the requirements of the Expect request-header field."
    },
    "E422": {
      "title": "Invalid file",
      "message": "The server cannot process the file data."
    },
    "E429": {
        "title": "Too many requests",
        "message": "Too many requests have been made. Please try again later."
      },
    "E496": {
        "title": "No Cert",
        "message": "The client must provide a certificate to fulfill the request."
    },
    "E498": {
        "title": "Token expired",
        "message": "Token was expired or is in invalid state."
    },
    "E499": {
        "title": "Token required",
        "message": "A token is required to fulfill the request.",
        "1": {
            "title": "Unathorized client",
            "message": "Client is not allowed to initiate browser login with given response_type."
        },
        "2": {
            "title": "Internal authorization error",
            "message": "The last step of authorization flow cannot be completed due to internal server error."
        }
    },
    "E500": {
        "title": "Internal Server Error",
        "message": "The server encountered an internal error and was unable to complete your request."
    },
    "E501": {
        "title": "Not Implemented",
        "message": "The server either does not recognize the request method, or it lacks the ability to fulfil the request."
    },
    "E502": {
        "title": "Bad Gateway",
        "message": "The server was acting as a gateway or proxy and received an invalid response from the upstream server."
    },
    "E503": {
        "title": "Service Unavailable",
        "message": "The server is currently unavailable (because it is overloaded or down for maintenance)."
    }
};
/* tslint:enable max-line-length */
/* tslint:enable quotemark */
